import { type Context, createContext } from 'react';

import { YScale } from '../types/histogram.js';

export const HistogramYScales: Context<YScale[]> = createContext<YScale[]>([]);

HistogramYScales['displayName'] = 'HistogramYScales';
